/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuTypeahead_viewer = {
    readonly itemFacetSearch?: {
        readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuSearchResults_itemFacetSearch">;
    } | null;
    readonly " $refType": "SbSharedRefineMenuTypeahead_viewer";
};
export type SbSharedRefineMenuTypeahead_viewer$data = SbSharedRefineMenuTypeahead_viewer;
export type SbSharedRefineMenuTypeahead_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuTypeahead_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuTypeahead_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuTypeahead_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "searchString",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "facetName",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userCountryCode",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasQuery",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "itemFacetSearch",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "facetName",
              "variableName": "facetName"
            },
            {
              "kind": "Variable",
              "name": "searchString",
              "variableName": "searchString"
            },
            {
              "kind": "Variable",
              "name": "uriRef",
              "variableName": "uriRef"
            }
          ],
          "concreteType": "ItemFacetsQueryConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefineMenuSearchResults_itemFacetSearch",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'e242871bd4a40ee61de59897d545d2a6';
export default node;
